/**
 * Bulk-Freigabe-Aktion des „Bereit"-Tabs (T8): sammelt ALLE pending
 * `auto_safe`-IDs des Laufs (Seiten-Schleife, s. `collectPendingSuggestionIds`)
 * und ruft `apply` einmalig mit der Gesamtmenge auf. `appliedIds` wird für
 * „Alles rückgängig" (T13/P2) ans Ergebnis-Panel weitergereicht — `revertSuggestions`
 * ist für nicht-übernommene ids ein No-Op (`skipped`/`no_previous`).
 */
import { useState } from 'react'

import type { ApplyResult } from '@/lib/api/channel-content-bulk'

import { collectPendingSuggestionIds } from '../hooks/collectPendingSuggestionIds'

export function useApproveAllSuggestions(
  runId: string,
  mutateAsync: (payload: { suggestion_ids: string[] }) => Promise<ApplyResult>,
) {
  const [result, setResult] = useState<ApplyResult | null>(null)
  const [appliedIds, setAppliedIds] = useState<string[]>([])
  const [approving, setApproving] = useState(false)

  const handleApproveAll = async () => {
    setApproving(true)
    try {
      const ids = await collectPendingSuggestionIds(runId)
      if (ids.length > 0) {
        setResult(await mutateAsync({ suggestion_ids: ids }))
        setAppliedIds(ids)
      }
    } finally {
      setApproving(false)
    }
  }

  return { result, appliedIds, approving, handleApproveAll }
}
